import _defineProperty from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
import { LocalizeDataAttributes } from "./model";

var Localize = function Localize(_ref) {
  var _i;

  var t = _ref.pluralize,
      e = _ref.name,
      a = _ref.children;
  var o = void 0 !== t && Boolean(t) && t > 0,
      i = (_i = {}, _defineProperty(_i, LocalizeDataAttributes.name, e), _defineProperty(_i, LocalizeDataAttributes.pluralize, o ? t : void 0), _defineProperty(_i, LocalizeDataAttributes.count, o || void 0), _i);
  return React.createElement("var", Object.assign({}, i), a);
};

export default Localize;